import React, { Component } from 'react'
import { Select, Button } from 'loyal-react'
import { SelectMobileOperator } from 'features/SelectMobileOperator'
import { SelectValuesRecharge } from 'features/SelectValuesRecharge'
import PropTypes from 'prop-types'
import DatePicker from 'features/DatePicker'
import PeriodScheduleRecharge from 'features/CellphoneRecharge/ScheduleRecharge/PeriodScheduleRecharge'
import { PhoneNumber } from 'features/CellphoneRecharge/PhoneNumber'
import moment from 'moment'

const selectOptions = [
  {
    text: 'Recarga de celular',
    value: 1
  }
]

class SchedulingOrderForm extends Component {
  constructor (props) {
    super(props)
    this.state = { scheduledOrder: props.scheduledOrder }
    this.saveScheduledOrder = this.saveScheduledOrder.bind(this)
    this.onChangeSchedulingDate = this.onChangeSchedulingDate.bind(this)
    this.onChangeService = this.onChangeService.bind(this)
    this.saveSchedulingOrder = this.saveSchedulingOrder.bind(this)
    this.onChangeEndDate = this.onChangeEndDate.bind(this)
    this.onChangeInitialDate = this.onChangeInitialDate.bind(this)
    this.onChangeOperator = this.onChangeOperator.bind(this)
    this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this)
    this.cancelSchedule = this.cancelSchedule.bind(this)
  }

  saveScheduledOrder () {
    this.props.onSaveScheduledOrder(this.state.scheduledOrder)
  }

  onChangeSchedulingDate (date) {
    let scheduledOrder = this.state.scheduledOrder || {}
    this.setState({
      scheduledOrder: {
        ...scheduledOrder,
        schedulingDate: date
      }
    })
  }

  onChangeService (item) {
    let scheduledOrder = this.state.scheduledOrder || {}
    this.setState({
      scheduledOrder: {
        ...scheduledOrder,
        serviceId: item.serviceId,
        serviceIdScheduling: item.serviceId,
        creditValue: item.costPrice,
        pointValue: item.sellingPrice
      }
    })
  }

  onChangePhoneNumber (e) {
    let scheduledOrder = this.state.scheduledOrder || {}
    this.setState({
      scheduledOrder: {
        ...scheduledOrder,
        areaCode: e.areaCode,
        phone: e.phoneNumber
      }
    })
  }

  saveSchedulingOrder () {
    this.props.onSaveScheduledOrder(this.state.scheduledOrder)
  }

  cancelSchedule () {
    this.props.onCancelSchedule()
  }
  onChangeEndDate (date) {
    let scheduledOrder = this.state.scheduledOrder || {}
    this.setState({ scheduledOrder: { ...scheduledOrder, endDate: date } })
  }
  onChangeInitialDate (date) {
    let scheduledOrder = this.state.scheduledOrder || {}
    this.setState({ scheduledOrder: { ...scheduledOrder, initialDate: date } })
  }
  onChangeOperator (e) {
    let scheduledOrder = this.state.scheduledOrder || {}
    this.setState({
      scheduledOrder: {
        ...scheduledOrder,
        operator: e.value,
        operatorKey: e.value
      }
    })
  }
  render () {
    let date = this.state.scheduledOrder.id ? (
      <DatePicker
        id='schedulingDate'
        labelDescription='Data do resgate'
        className='col-12 col-md-6 mt-2'
        required
        value={moment(this.state.scheduledOrder.schedulingDate)
          .utc()
          .format('DD/MM/YYYY')}
        minDate={moment(new Date())
          .add(1, 'days')
          .toDate()}
        onChange={this.onChangeSchedulingDate}
      />
    ) : (
      <PeriodScheduleRecharge
        onChangeInnitialDate={this.onChangeInitialDate}
        innitialDate={this.state.scheduledOrder.initialDate}
        onChangeEndDate={this.onChangeEndDate}
        endDate={this.state.scheduledOrder.endDate}
        maxQuantityMonths={24}
      />
    )

    return (
      <div className={`row px-0 pb-3 pt-1 border-top border-color-ui-3`}>
        <div className='profile-infos col-12 px-2'>
          <div className='row mx-0'>
            <Select
              id='escolha-servico'
              label='Escolha o serviço'
              className='col-12 col-md-6 mt-2'
              displayValue='text'
              selectedValue='value'
              options={selectOptions}
              value={selectOptions[0]}
              disabled
              required
            />
            <SelectMobileOperator
              id='escolha-parceiro'
              label='Escolha uma operadora'
              className='col-12 col-md-6 mt-2'
              value={this.state.scheduledOrder.operator}
              disabled={this.state.scheduledOrder.id}
              onChange={this.onChangeOperator}
            />
            <PhoneNumber
              operatorKey={this.state.scheduledOrder.operator}
              areaCode={this.state.scheduledOrder.areaCode}
              phoneNumber={this.state.scheduledOrder.phone}
              divContentClassName='col-12 col-md-6 mt-2'
              disabled={this.state.scheduledOrder.id}
              onChangePhoneNumber={this.onChangePhoneNumber}
              onChangeAreaCode={this.onChangePhoneNumber}
              required
            />
            <SelectValuesRecharge
              id='escolha-parceiro'
              label='Escolha valor de crédito'
              className='col-12 col-md-6 mt-2'
              operatorKey={this.state.scheduledOrder.operator}
              areaCode={this.state.scheduledOrder.areaCode}
              value={this.state.scheduledOrder.serviceIdScheduling}
              onChangeValue={this.onChangeService}
            />
            {date}
            <div className='col-12 col-md-6 mt-2 pl-3 pr-0'>
              <Button
                id={'btn-back-rating'}
                name={'btn-back-rating'}
                className='btn btn-double btn-featured btn-rating-modal col-12'
                text='Cancelar'
                onClick={this.cancelSchedule}
              />
            </div>
            <div className='col-12 col-md-6 mt-2 pl-3 pr-0'>
              <Button
                className='btn btn-sm btn-featured'
                text={
                  this.state.scheduledOrder.id
                    ? 'CONCLUIR EDIÇÃO'
                    : 'AGENDAR AGORA'
                }
                onClick={this.saveSchedulingOrder}
                loading={this.props.loading}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

SchedulingOrderForm.propTypes = {
  scheduledOrder: PropTypes.object,
  onSaveScheduledOrder: PropTypes.func,
  onCancelSchedule: PropTypes.func,
  loading: PropTypes.bool
}

export default SchedulingOrderForm



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/SchedulingOrderForm/SchedulingOrderForm.js